import { ConditionallyRenderedPortal } from "@jugl-web/utils/utils/ConditionallyRenderedPortal";
import { FC, ReactNode } from "react";
import { Draggable } from "react-beautiful-dnd";

export interface DraggableItemProps {
  id: string;
  index: number;
  children: ReactNode;
}

export const DraggableItem: FC<DraggableItemProps> = ({
  id,
  index,
  children,
}) => (
  <Draggable draggableId={id} index={index}>
    {(provided, snapshot) => (
      <ConditionallyRenderedPortal isEnabled={snapshot.isDragging}>
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {children}
        </div>
      </ConditionallyRenderedPortal>
    )}
  </Draggable>
);
